'use strict';

function FocusFactory($rootScope, $timeout) {
    'ngInject';
    return {
        focusOn: function(name) {
            console.log(name);
            $timeout(function (){
                $rootScope.$broadcast('focusOn', name);
            });
        }
    };
};

export default FocusFactory;
